import React from "react";
import styles from "./HowItWorks.module.css";
import commonStyles from "../../Shared/commonStyles.module.css";
import { FaShoppingCart, FaPlusCircle, FaPen, FaPhone } from "react-icons/fa";
import { Link } from "react-router-dom";
import HowItWorksStep from "./HowItWorksStep";

function HowItWorks() {
  return (
    <div className={`${commonStyles.section} ${styles.HowItWorks}`}>
      <h3 className={commonStyles.sectionHeader}>How It Works</h3>
      <div className={styles.Steps}>
        <HowItWorksStep
          stepNumber="1"
          stepHeader="Choose Your Gifts"
          stepText="Browse our full collection of products and hampers. Pick the gifts
              in the right colour and size for your recipient."
          stepIcon={<FaShoppingCart className={styles.CartIcon} />}
        />
        <div
          className={`${commonStyles.eyebrow}` + ` ${styles.BrowseProducts}`}
        >
          <Link to="/products">Browse Products</Link>
        </div>
        <HowItWorksStep
          stepNumber="2"
          stepHeader="ADD YOUR TEXT & DESIGN"
          stepText="Decide what names, messages, or designs you want on your product. Choose the text colour. "
          stepIcon={<FaPlusCircle className={styles.CartIcon} />}
        />        
        <HowItWorksStep
          stepNumber="3"
          stepHeader="GET IN TOUCH"
          stepText="Send us an email or WhatsApp with your chosen products (colour/size) and personalisation details (text/design/colour)."
          stepIcon={<FaPhone className={styles.CartIcon} />}
        />
         <div
          className={`${commonStyles.eyebrow}` + ` ${styles.BrowseProducts}`}
        >
          <Link to="/customer-services/Contact">Contact Us</Link>
        </div>
      </div>
    </div>
  );
}


export default HowItWorks;
